import { DEFAULT_INVALID_VALUE } from 'Common/constants/jasperReport';

export const handleInvalidSingleValueParameter = (value) => {
  const isValid =
    value !== null && value !== 'null' && typeof value !== 'undefined';
  return isValid ? value : DEFAULT_INVALID_VALUE.SINGLE;
};
